import { useState, useEffect } from 'react';
import { Util } from '@/utils/utils';
import { configuracoesService } from '@/services/configuracoes.service';
import { navItems, NavItem } from '@/data/sidebar-data';

export const useSidebar = () => {
  const [filteredNavItems, setFilteredNavItems] = useState<NavItem[]>([]);
  const [userName, setUserName] = useState('Usuário');
  const [userRole, setUserRole] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const util = new Util();

  useEffect(() => {
    initializeSidebar();
  }, []);

  const getUserRoleText = (role: string): string => {
    switch (role) {
      case 'revendedora':
        return 'REVENDEDOR(A)';
      case 'coordenadora':
        return 'COORDENADOR(A)';
      default:
        return role.toUpperCase();
    }
  }

  const initializeSidebar = async () => {
    setIsLoading(true);
    
    try {
      // Carregar configurações para filtrar ranking se necessário
      const configs = await configuracoesService.getAllConfigs();
      let filteredItems = removeRankingIfConfigIsZero(navItems, configs);
      filteredItems = checkNavBarPermission(filteredItems);
      setFilteredNavItems(filteredItems);
    } catch (error) {
      console.error('Erro ao carregar configurações:', error);
      // Fallback sem configurações
      const filteredItems = checkNavBarPermission(navItems);
      setFilteredNavItems(filteredItems);
    }

    // Carregar dados do usuário
    const userData = localStorage.getItem('userlogged');
    if (userData) {
      try {
        const user = JSON.parse(userData);
        const completeName = user.nome_razao_social;
        const nameAux = completeName.split(' ');
        setUserName(nameAux[0] + (nameAux[1] ? ' ' + nameAux[1][0] + '.' : ''));
        setUserRole(getUserRoleText(user.role));
      } catch (error) {
        console.error('Erro ao parse dos dados do usuário:', error);
      }
    }

    setIsLoading(false);
  };

  const removeRankingIfConfigIsZero = (navItems: NavItem[], configs: any[]): NavItem[] => {
    // Procura a configuração de "ranking"
    const rankingConfig = configs.find(config => config.name === 'ranking');
    
    // Se a configuração existir e o valor for '0', remove o item "Ranking Vendas"
    if (rankingConfig && rankingConfig.value === '0') {
      return navItems.filter(item => item.displayName !== 'Ranking Vendas');
    }
  
    // Se não precisar remover, retorna os navItems como estão
    return navItems;
  };

  const checkNavBarPermission = (items: NavItem[]): NavItem[] => {
    const newNavItems: NavItem[] = [];
    
    for (const item of items) {
      // Se é um navCap (categoria), verifica se tem permissões
      if (item.navCap) {
        if (!item.permissions || util.checkPermissions(item.permissions)) {
          newNavItems.push(item);
        }
      }
      // Se é um item de menu, verifica permissões
      else if (item.displayName) {
        if (!item.permissions || util.checkPermissions(item.permissions)) {
          newNavItems.push(item);
        }
      }
    }

    return newNavItems;
  };

  return {
    filteredNavItems,
    userName,
    userRole,
    isLoading,
    refetch: initializeSidebar
  };
};
